import { resolveDirective as _resolveDirective, createElementVNode as _createElementVNode, withDirectives as _withDirectives, createTextVNode as _createTextVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "a-feeInfo__valueDisplay" }
const _hoisted_2 = { class: "a-feeInfo__primary" }
const _hoisted_3 = { class: "a-feeInfo__valueTitle" }
const _hoisted_4 = { class: "a-feeInfo__value" }
const _hoisted_5 = {
  key: 0,
  class: "a-feeInfo__secondary"
}
const _hoisted_6 = { class: "a-feeInfo__valueDisplay" }
const _hoisted_7 = { class: "a-feeInfo__primary" }
const _hoisted_8 = { class: "a-feeInfo__valueTitle" }
const _hoisted_9 = { class: "a-feeInfo__value" }
const _hoisted_10 = {
  key: 0,
  class: "a-feeInfo__secondary"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_translate = _resolveDirective("translate")!

  return (_ctx.canDisplayTicketFees)
    ? (_openBlock(), _createElementBlock("div", {
        key: 0,
        class: _normalizeClass([{ '-opacity': _ctx.hasOpacity, '-morePadding': _ctx.currencyHandler.isSecondaryCurrencyDisplayed }, "a-FeeInfo__container"])
      }, [
        _createElementVNode("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            _createElementVNode("div", _hoisted_3, [
              _withDirectives(_createElementVNode("span", null, null, 512), [
                [_directive_translate, { key: _ctx.Translation.Ticket_fees }]
              ]),
              _createTextVNode(": ")
            ]),
            _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.currencyHandler.displayPrimaryCurrency(_ctx.totalFeeValue)), 1)
          ]),
          (_ctx.currencyHandler.isSecondaryCurrencyDisplayed)
            ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                _createElementVNode("span", null, _toDisplayString(_ctx.currencyHandler.displaySecondaryCurrency(_ctx.totalFeeValue)), 1)
              ]))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          _createElementVNode("div", _hoisted_7, [
            _createElementVNode("div", _hoisted_8, [
              _withDirectives(_createElementVNode("span", null, null, 512), [
                [_directive_translate, { key: _ctx.Translation.Ticket_total }]
              ]),
              _createTextVNode(": ")
            ]),
            _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.currencyHandler.displayPrimaryCurrency(_ctx.totalValue)), 1)
          ]),
          (_ctx.currencyHandler.isSecondaryCurrencyDisplayed)
            ? (_openBlock(), _createElementBlock("div", _hoisted_10, [
                _createElementVNode("span", null, _toDisplayString(_ctx.currencyHandler.displaySecondaryCurrency(_ctx.totalValue)), 1)
              ]))
            : _createCommentVNode("", true)
        ])
      ], 2))
    : _createCommentVNode("", true)
}